import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  root: {
    padding: '0px 24px',
    width: '100%',
    height: theme.settings.size.desktop.menuHeight,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    zIndex: 100,
  },
  menuItems: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
  },
  menuItem: {
    margin: '16px',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    '&:focus': {
      textDecoration: 'none',
    },
    '& h2::after': {
      content: "''",
      display: 'block',
      width: 0,
      height: 4,
      marginTop: 8,
      background: theme.palette.colors.red,
      transition: 'width .3s',
    },
    '& h2:hover::after': {
      width: '100%',
    },
  },
  menuItemActive: {
    '& h2::after': {
      content: "''",
      display: 'block',
      width: '100%',
      height: 4,
      marginTop: 8,
      background: theme.palette.colors.red,
    },
  },
  rightBar: {
    display: 'flex',
  },
  userLabel: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: 16,
  },
  displayName: {
    borderBottom: '1px dashed #000000',
    marginBottom: 6,
  },
  loginLink: {
    marginRight: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    fontWeight: 700,
    '&:hover': {
      color: theme.palette.colors.black,
    },
    '&:focus': {
      color: theme.palette.colors.black,
      textDecoration: 'none',
    },
  },
}));



// WEBPACK FOOTER //
// ./src/layouts/NonAuthLayout/components/Menu/components/DesktopMenu/useStyles.js